export default {
  BusinessStockDeliveryResult: {
    header: {
      queryCode: 'Order No.',
      outLogicWarehouseCode: 'Outbound Logic Warehouse',
      outLogicWarehouseCodeText: 'Please enter logic warehouse code',
    },

    table: {
      resultCode: 'Outbound result Order No.',
      odoCode: 'Outbound Notice Number',
      outTypeMeaning: 'Outbound Type',
      status: 'Outbound Status',
      alreadyOutQty: 'Quantity Shipped',
      outLogicWarehouseCode: 'Outbound logic warehouse code',
      outLogicWarehouseName: 'Outbound logic warehouse name',
      shopName: 'Store',
      channelTypeCodeMeaning: 'Sales Channel',
    }
  }
};
